import { RGBColor } from "react-color";

/**
 * @deprecated Use `tinycolor(hex).setAlpha(alpha).toRgbString()` from tinycolor2 instead
 */
export const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/**
 * @deprecated Use `tinycolor({ r, g, b, a }).toRgbString()` from tinycolor2 instead
 */
export const createRgbString = (rgb: RGBColor): string => {
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a ?? 1})`;
};
